import { useOffline } from '../offline'

export type SyncKind = 'synced' | 'saving' | 'offline' | 'error' | 'auth-paused'

const labels: Record<SyncKind, string> = {
  synced: 'Synced',
  saving: 'Saving',
  offline: 'Offline',
  error: 'Retry sync',
  'auth-paused': 'Sign in to sync',
}

export function SyncState({ state, pending, message, onRetry }: { state?: SyncKind; pending?: number; message?: string; onRetry?: () => void }) {
  const content = `${labels[state ?? 'synced']}${pending ? ` · ${pending}` : ''}`
  if (state === 'error' && onRetry) {
    return <button type="button" className="sync-state sync-error" aria-live="polite" aria-label={message ?? content} onClick={onRetry}><span className="sync-dot" aria-hidden="true" /><span>{content}</span></button>
  }
  return (
    <div className={`sync-state sync-${state ?? 'synced'}`} role="status" aria-live="polite" aria-atomic="true" title={message}>
      <span className="sync-dot" aria-hidden="true" />
      <span>{content}</span>
    </div>
  )
}

export function ConnectedSyncState({ override }: { override?: SyncKind }) {
  const { snapshot, retry } = useOffline()
  const state = override ?? snapshot.phase
  return <SyncState state={state} pending={snapshot.pending} message={snapshot.message} onRetry={() => void retry()} />
}
